import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ContentWrapper, Panel } from '@checkmarx/cx-ui';
import SecurityTabsContainer from './securityTabs';

@inject('translationsStore','routesStore') @observer
export default class SecuritySettings extends Component {
    componentDidMount() {
        this.props.routesStore.setSettingsSelectedTabId(this.props.tabId);
    }

  render() {

        return (
            <ContentWrapper className='content-wrapper' dataCy={'security-settings-screen'}>
                <Panel className='content-left-hand'>
                    <div className='security-title'>
                        {this.props.translationsStore.translate('SECURITY_SETTINGS_TITLE')}
                    </div>
                    <div className='setting-sub-title'>
                        {this.props.translationsStore.translate('SECURITY_SETTINGS_SUB_TITLE')}
                    </div>
                </Panel>
                <Panel className='content-right-hand'>
                    <SecurityTabsContainer />
                </Panel>
            </ContentWrapper>
        );
    }
}